import { useMemo } from 'react';

var useGetBlockData = function useGetBlockData(editorState, blockKey, entityKey) {
  return useMemo(function () {
    var _contentState$getBloc;

    var contentState = editorState.getCurrentContent();
    var blockData = blockKey !== undefined ? (_contentState$getBloc = contentState.getBlockForKey(blockKey)) === null || _contentState$getBloc === void 0 ? void 0 : _contentState$getBloc.getData().toObject() : undefined;
    var entityData = entityKey !== undefined ? contentState.getEntity(entityKey).getData() : undefined;
    return {
      blockData: blockData,
      entityData: entityData
    };
  }, [blockKey, editorState, entityKey]);
};

export default useGetBlockData;